import React, { useState } from "react";
import { convertStringToArray } from "../../../Utils/utils";
import LightBox from "../../../components/LightBox/LightBox";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";

const PhotoGalleryRehab = ({ data }) => {
  const { getText } = useLanguageTranslation();
  const photoArray = convertStringToArray(data?.field_events_image);
  const [visible, setVisible] = React.useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const photoGallery = photoArray?.map((url) => {
    return {
      title: url.title,
      src: `http://164.52.201.69${url.file_path}`,
    };
  });
  console.log(photoArray);
  return (
    <>
      <div className="container">
        <div className="title-sec">
          <h4>{getText("Photo Gallery", "फोटो गैलरी")}</h4>
        </div>
        <div className="row mb-5">
          {photoArray?.length === 0 ? (
            <div className="container">
              <div className="">
                <h4 className="title4">
                  {" "}
                  {getText("No photos available", "कोई फ़ोटो उपलब्ध नहीं")}
                </h4>
              </div>
            </div>
          ) : (
            photoArray?.map((item, index) => (
              <div
                key={index}
                className="col-12 col-sm-12 col-md-4 col-lg-4 mvDescWrap mb-3"
              >
                <div className="card-sec">
                  <div
                    className="img-sec photo-gallery-card"
                    onClick={() => {
                      setVisible(true);
                      setActiveIndex(index);
                    }}
                  >
                    <img
                      alt={item.file_path}
                      src={`${process.env.REACT_APP_IMAGE_URL}/${item.file_path}`}
                    />
                  </div>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
      <LightBox
        visible={visible}
        setVisible={setVisible}
        photoGallery={photoGallery}
        activeIndex={activeIndex}
      />
    </>
  );
};

export default PhotoGalleryRehab;
